import api from './api'

export interface ReportFilters {
  dateStart?: string
  dateEnd?: string
  projectTypes?: string[]
  estimatorId?: string
  clientId?: string
  status?: string
  isPublicWorks?: string
}

function buildParams(filters: ReportFilters): URLSearchParams {
  const params = new URLSearchParams()
  if (filters.dateStart) params.set('dateStart', filters.dateStart)
  if (filters.dateEnd) params.set('dateEnd', filters.dateEnd)
  if (filters.projectTypes && filters.projectTypes.length > 0) {
    params.set('projectTypes', filters.projectTypes.join(','))
  }
  if (filters.estimatorId) params.set('estimatorId', filters.estimatorId)
  if (filters.clientId) params.set('clientId', filters.clientId)
  if (filters.status) params.set('status', filters.status)
  if (filters.isPublicWorks) params.set('isPublicWorks', filters.isPublicWorks)
  return params
}

export const reportsService = {
  async getReport(reportType: string, filters: ReportFilters = {}) {
    const params = buildParams(filters)
    const { data } = await api.get(`/reports/${reportType}?${params}`)
    return data.data
  },
}

export interface OpportunityQueueReportData {
  summary: {
    totalOpen: number
    dueThisWeek: number
    overdue: number
    unassignedCount: number
  }
  chartData: {
    workloadByEstimator: Array<{
      estimatorId: string | null
      estimatorName: string
      count: number
    }>
  }
  rows: Array<{
    estimatorId: string | null
    estimatorName: string
    opportunities: Array<{
      id: string
      opportunityNumber: string | null
      title: string
      status: string
      source: string
      lead: string | null
      estimatorNotes: string | null
      createdAt: string
      dueDate: string | null
      projectAddress: string | null
      projectCity: string | null
      projectTypes: string
      contactName: string | null
      contactEmail: string | null
      contactPhone: string | null
      daysUntilDue: number | null
      aging: number
    }>
  }>
}

export async function getOpportunityQueueReport(
  filters: ReportFilters,
): Promise<OpportunityQueueReportData> {
  const params = buildParams(filters)
  const { data } = await api.get(`/reports/opportunity-queue?${params}`)
  return data.data as OpportunityQueueReportData
}

export async function downloadOpportunityQueueCsv(
  filters: ReportFilters,
): Promise<{ blob: Blob; filename: string }> {
  const params = buildParams(filters)
  const res = await api.get(`/reports/opportunity-queue/export.csv?${params}`, {
    responseType: 'blob',
  })
  const disposition = (res.headers?.['content-disposition'] ?? '') as string
  const match = disposition.match(/filename="?([^"]+)"?/i)
  const filename = match?.[1] ?? 'paver-opportunity-queue.csv'
  return { blob: res.data as Blob, filename }
}
